import { TBelongsTo } from '../../_generics';

import _ from 'lodash';

export function getIndexOfAfterKey(collection: TBelongsTo[], afterKey: string): number {
  const indexOfStepBefore = collection.find((i) => i.key === afterKey)?.belongsToPosition ?? -1;
  const indexOfStepAfter = collection.reduce(
    (minimum, i) =>
      i.belongsToPosition < minimum && i.belongsToPosition > indexOfStepBefore ? i.belongsToPosition : minimum,
    Number.MAX_VALUE,
  );
  if (indexOfStepAfter > indexOfStepBefore + 2) {
    return indexOfStepBefore + 1;
  }
  return (indexOfStepBefore + indexOfStepAfter) / 2;
}

export function cloneOrThrow<T extends { key: string }>(collection: T[], key: string): T {
  const item = collection.find((i) => i.key === key);
  if (!item) {
    throw new Error(`Could not find the item with key ${key}`);
  }

  return _.cloneDeep(item);
}

export function findNextKey(collection: TBelongsTo[], prefix: string) {
  const max = Math.max(...collection.map((k) => Number.parseInt(RegExp('[0-9]+').exec(k.key)?.[0] ?? '0')));
  return `${prefix}.` + (max + 1).toFixed(0).padStart(4, '0');
}
